import styled from "styled-components";
import { ThemeType } from "../../types/Theme";

export const Button = styled.button<{ theme: ThemeType, disabled?: boolean, $hasOptions?: boolean }>`
  position: relative;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.mode === 'dark' ? theme.colors.tertiary : theme.colors.white};
  background-color: ${({ theme, disabled }) => disabled ? theme.colors.primary : theme.colors.primary};
  font-weight: ${({ theme }) => theme.mode === 'dark' ? 'bold' : 'normal'};
  border-radius: 3rem;
  padding: 1rem 5rem;
  z-index: 1;
  height: 32px;
  svg{
    width: 3.5rem;
    width: 3.5rem;
    margin-right: 1rem;
    margin-left: 1rem;
    flex-shrink: 0;
  }
  .loading {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .options-area {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 1rem;
    padding-right: 2rem;
    cursor: pointer;
    transition: background-color 0.2s;
    border-radius: 0 3rem 3rem 0;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }

    svg {
      width: 4rem;
      margin: 0;
      fill: currentColor;
    }
  }
`;
